// extracted by mini-css-extract-plugin
export var errorsContainer = "_vc-1";
export var link = "_vc-0";